
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options, Vue } from "vue-class-component";

import HotspotLogoTips from "@/components/Common/HotspotLogoTips.vue";
import HotspotContentList from "@/components/Common/HotspotContentList.vue";

@Options({
  components: {
    HotspotContentList,
    HotspotLogoTips,
  },
  props: {
    modules: Object,
  },
  data() {
    return {};
  },
  inject: ["outsideIframeShow"],
  methods: {
    audiobgstop() {
      this.$emit("audiobgstop");
    },
    goZsPage() {
      this.$storage.goZsAppPage(this, 7);
      // window.open(this.$storage.ZS_DOWNLOAD_URL);
    },
    click(k: number) {
      this.currentIndex = k;
      this.showDetail = true;
    },
  },
})
export default class Hotspot6 extends Vue {}
